import {toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu} from '../../../partials'
import {useAuth} from '../../../../app/modules/auth'

const Navbar = () => {
  const {currentUser} = useAuth()

  const displayName = currentUser
    ? `${currentUser.first_name || ''} ${currentUser.last_name || ''}`.trim() ||
      currentUser.username
    : 'Admin'

  const roleLabel = 'Administrator'

  return (
    <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0}}>
      {/* Notification bell */}
      <button
        style={{
          position: 'relative',
          width: '2.25rem',
          height: '2.25rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          border: 'none',
          backgroundColor: 'transparent',
          cursor: 'pointer',
          color: '#434652',
        }}
        onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.backgroundColor = '#f2f4f6')}
        onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.backgroundColor = 'transparent')}
      >
        <span className='material-symbols-outlined' style={{fontSize: '22px'}}>
          notifications
        </span>
        {/* Orange notification dot */}
        <span
          style={{
            position: 'absolute',
            top: '0.4rem',
            right: '0.4rem',
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: '#ffb870',
            border: '1.5px solid white',
          }}
        />
      </button>

      {/* Settings */}
      <button
        style={{
          width: '2.25rem',
          height: '2.25rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          border: 'none',
          backgroundColor: 'transparent',
          cursor: 'pointer',
          color: '#434652',
        }}
        onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.backgroundColor = '#f2f4f6')}
        onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.backgroundColor = 'transparent')}
      >
        <span className='material-symbols-outlined' style={{fontSize: '22px'}}>
          settings
        </span>
      </button>

      {/* Divider */}
      <div
        style={{
          width: '1px',
          height: '2rem',
          backgroundColor: 'rgba(195, 198, 212, 0.4)',
          margin: '0 0.25rem',
        }}
      />

      {/* User info + avatar — trigger for HeaderUserMenu dropdown */}
      <div style={{position: 'relative'}}>
        <div
          className='cursor-pointer'
          style={{display: 'flex', alignItems: 'center', gap: '0.75rem'}}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <div className='navbar-user-meta' style={{textAlign: 'right'}}>
            <p style={{margin: 0, fontSize: '0.75rem', fontWeight: 700, color: '#191c1e', lineHeight: 1.2}}>
              {displayName}
            </p>
            <p style={{margin: 0, fontSize: '0.625rem', color: '#434652', fontWeight: 500}}>
              {roleLabel}
            </p>
          </div>
          <img
            src={toAbsoluteUrl('/media/avatars/blank.png')}
            alt={displayName}
            style={{
              width: '2.25rem',
              height: '2.25rem',
              borderRadius: '50%',
              objectFit: 'cover',
              border: '2px solid white',
              boxShadow: '0 1px 4px rgba(0,52,127,0.12)',
            }}
          />
        </div>
        <HeaderUserMenu />
      </div>
    </div>
  )
}

export {Navbar}
